import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useRef, useState } from 'react';
const RIPPLE_DURATION_MS = 600;
interface RippleItem {
  id: number;
  size: number;
  x: number;
  y: number;
}
export function useRipple() {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [ripples, setRipples] = useState(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const pendingTimeouts = useRef(t1);
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => () => {
      for (const timeout of pendingTimeouts.current) {
        clearTimeout(timeout);
      }
      pendingTimeouts.current = [];
    };
    t3 = [];
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = event => {
      const button = event.currentTarget;
      const rect = button.getBoundingClientRect();
      const size = Math.max(rect.width, rect.height);
      const x = event.clientX - rect.left - size / 2;
      const y = event.clientY - rect.top - size / 2;
      const newRipple = {
        id: Date.now(),
        x,
        y,
        size
      };
      setRipples(prevRipples => [...prevRipples, newRipple]);
      const timeout_0 = setTimeout(() => {
        pendingTimeouts.current = pendingTimeouts.current.filter(pending => pending !== timeout_0);
        setRipples(prevRipples_0 => prevRipples_0.filter(ripple => ripple.id !== newRipple.id));
      }, RIPPLE_DURATION_MS);
      pendingTimeouts.current.push(timeout_0);
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const createRipple = t4;
  let t5;
  if ($[5] !== ripples) {
    t5 = {
      ripples,
      createRipple
    };
    $[5] = ripples;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}